export default __webpack_public_path__ + "static/media/fast-icon.dbb971a7.svg";